// extracted by mini-css-extract-plugin
export default {"wrapper":"Telegram_wrapper__bQcqL","userBg":"Telegram_userBg__OorX4"};